'use strict';
var $ = require('jquery');
/**
 * futureRules is extension for jquery validator functionality
 *
 * Future Rules is a concept introduced to facilitate business requirements to trigger certain UX queues as user types
 * Jquery Validation doesn't support event based rules, thus additional layer is created
 *
 * Future Rules converts elements future rule to a jquery rule once conditions have been met.
 * This is achieved by replacing attribute data-future-rule-* with data-rule-* once the conditions have been met.
 *
 * Currently supported future rule:
 *  data-future-rule-minlength
 */

/**
 * Function to be invoked after all fields have been populated with their previous values
 * This function evaluates if future rules should be applied on any of the elements
 * @param form
 */
function renderingDone(form) {
    $('input[data-future-rule-minlength]', form).each(function(index, el){
        evalMinLength(el);
    });
}

/*
 * Find all future rules in provided form. Ignores fields configured to be ignored by validator
 * For now only data-future-rule-minlength is supported
 */
function getFutureRules(form) {
    var ignore = [];

    var validator = $(form).data("validator");
    if (validator) {
        ignore = $(form).data("validator").settings.ignore;
    }

    return $('input[data-future-rule-minlength]', form).not(ignore);
}

/*
 * Return true only if there are no future rules on the form
 */
function hasNoFutureRules(form) {
    return getFutureRules(form).length === 0;
}

function elemHasNoFutureRule(element) {
    return (typeof $(element).attr('data-future-rule-minlength') === "undefined");
}

/*
 * Applies all future rules on the form
 */
function applyAllFutureRules(form) {
    getFutureRules($(form)).each(function(i, el) {
        evalMinLength(el, true);
    });
}

/*
 * If element has attribute data-future-rule-minlength and its value satisfies the condition
 * attribute will be converted to jquery data validation rule and future rule removed
 */
function evalMinLength(el, force) {
    var element = $(el);
    var minLength = element.attr('data-future-rule-minlength');
    if (minLength && (force || (element.val().length >= minLength))) {
        element.removeAttr('data-future-rule-minlength');
        element.attr('data-rule-minlength', minLength);
        console.log('Added minlength=' + minLength + ' rule to ' + element.attr('name'));
    }
}

//public
module.exports.renderingDone = renderingDone;
module.exports.hasNoFutureRules = hasNoFutureRules;
module.exports.elemHasNoFutureRule = elemHasNoFutureRule;
module.exports.applyAllFutureRules = applyAllFutureRules;
//protected
module.exports.evalMinLength = evalMinLength;


//////////////////
// WEBPACK FOOTER
// ./src/shared/scripts/modules/forms/futureRules.js
// module id = s5DP
// module chunks = 1 2 5